// src/i18n.js

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Örnek dil dosyaları
import tr from './locales/tr/translation.json'
import en from './locales/en/translation.json'
import de from './locales/de/translation.json'
import fr from './locales/fr/translation.json'
import el from './locales/el/translation.json'
import nl from './locales/nl/translation.json'

const LANGUAGE_STORAGE_KEY = 'preferredLanguage'

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en'

  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en'
  } catch (error) {
    console.warn('Dil tercihi okunamadı, varsayılan dil kullanılacak.', error)
    return 'en'
  }
}

i18n.use(initReactI18next).init({
  resources: {
    tr: {
      translation: tr,
    },
    en: {
      translation: en,
    },
    de: {
      translation: de,
    },
    fr: {
      translation: fr,
    },
    el: {
      translation: el,
    },
    nl: {
      translation: nl,
    },
  },
  lng: getInitialLanguage(), // Varsayılan dil (ilk girişte İngilizce)
  fallbackLng: 'en', // Bir çeviri bulunmazsa geri düşülecek dil
  interpolation: {
    escapeValue: false, // React zaten XSS koruması sağlıyor
  },
})

if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lng)
    } catch (error) {
      console.warn('Dil tercihi kaydedilemedi.', error)
    }
  })
}

export default i18n
